const QUESTION_TYPES = {
  text: 1,
  other: 2,
};

export default {
  QUESTION_TYPES,
};
